import Api, {didAbort, requestHandler} from '@/providers/Api';
import { SET_TOKEN_MUTATION, SIGN_OUT_ACTION} from '@/store';
import router from '@/router';

export const initializeRefreshTokenInterceptor = (store) => {
  let isRefreshing = false;
  let refreshSubscribers = [];
  const subscribeTokenRefresh = (cb) => refreshSubscribers.push(cb);

  const onRefreshed = (token) => {
    refreshSubscribers.map((cb) => cb(token));
    refreshSubscribers = [];
  };

  return function (error) {
    const originalRequest = error.config;
    if (didAbort(error) || error.config.url === '/?r=auth/refresh-token') {
      return Promise.reject(error);
    }
    if (error.response && error.response.status === 401) {
      if (!isRefreshing) {
        isRefreshing = true;
        Api.refreshTokenRequest()
          .then(({ token: newToken = null }) => {
            store.commit(SET_TOKEN_MUTATION, newToken);
            isRefreshing = false;
            onRefreshed(newToken);
          })
          .catch(() => {
            delete requestHandler.defaults.headers.common.Authorization;
            store.dispatch(SIGN_OUT_ACTION).then(() => {
              isRefreshing = false;
              onRefreshed(null);
              router.push('/login');
            });
          });
      }

      return new Promise((resolve, reject) => {
        subscribeTokenRefresh((token) => {
          if (token) {
            // replace the expired token and retry
            originalRequest.headers['Authorization'] = `Bearer ${token}`;
            resolve(requestHandler(originalRequest));
          } else {
            reject(error);
          }
        });
      });
    }
    return Promise.reject(error);
  };
};
